const styles = {
  actions: {
    width: '100%',
    display: 'flex',
    gap: 1,
    px: 1,
  },
  defaultButton: {
    color: 'text.primaryDark',
    width: '100%',
  },
  progress: {
    color: '#fff',
  },
  primaryButton: {
    // maxWidth: '160px',
    width: '100%',
  },
}

export default styles
